import React, { Component, useEffect, useState } from "react";
import { GetBatches } from "./API";
import BatchItem from "./BatchItem";
import { Translate } from "react-localize-redux";

const BatchList = props => {
  window.scrollToSelected();
  const [data, setData] = useState([]);
  useEffect(() => {
    GetBatches().then(data => {
      setData(data);
    });
  }, []);

  return (
    <div class="card">
      <div class="card-block">
        <h4 class="card-title m-t-0">
         
          <Translate id="batches.name" />
        </h4>
        <h6 class="card-subtitle m-b-10 text-muted">
         
          <Translate id="batches.desc" />
        </h6>
        <div class="text-center batchContainer">
          {data.map((item, key) => (
            <BatchItem
              item={item}
              key={item.id}
              currentBatch={props.batchNum}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BatchList;



// WEBPACK FOOTER //
// ./src/pages/results/BatchList.js